import { render, staticRenderFns } from "./EShop.vue?vue&type=template&id=27029bc0&scoped=true&"
var script = {}
import style0 from "./EShop.vue?vue&type=style&index=0&id=27029bc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27029bc0",
  null
  
)

export default component.exports